export class EmployeeEmailHistories {
  Id: number;
  EmpCode: number;
  Email: string;
  StartDate: Date;
  EndDate: Date;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  IsActive: boolean;
  //to display error message for duplicate records in history tab
  hasDuplicateNameError?: boolean;
  duplicateNameMessage?: string;
  isInvalidEmail?: boolean;
  InvalidMail?: boolean;
  InvalidMailMessage?: string;
}
